<script>
    import http from "../http";
    import dayjs from "dayjs";
    import FBarDate from "@/components/FBarDate";
    import FTable from "@/components/FDataInterator";
    import { mapGetters } from "vuex";

    export default {
        name: "FPageStuckProducts",
        components: { FBarDate, FTable },

        data: () => ({
            products: null,
            updatedAt: null
        }),

        mounted() {
            this.getProductsList();
        },

        methods: {
            async getProductsList() {
                const id = this.companySelected.id;
                const uri = `estoque/produtos/${id}?min=1`;

                try {
                    const raw = (await http.get(uri, {
                        clearCacheEntry: navigator.onLine
                    })).data;

                    const products = raw.data.map(p => {
                        const descricao =
                            p.descricaoGrupoProduto || p.descricaoProduto;

                        return {
                            title: descricao,
                            fields: {
                                atual: p.estoqueAtual,
                                minimo: p.estoqueMinimo
                            }
                        };
                    });

                    this.products = products;
                    this.updatedAt = dayjs(raw.lastSale)
                        .add(3, "hours")
                        .valueOf();
                } catch (e) {
                    this.products = null;
                    this.updatedAt = null;

                    console.log(e);
                }
            }
        },

        computed: {
            ...mapGetters(["companySelected"])
        }
    };
</script>

<template>
    <section>
        <FBarDate @change='this.getProductsList' disabledNav :lastUpdate='updatedAt' showDay/>

        <FTable v-if='products' :items='products || []' style='margin-top: 10px'/>
    </section>
</template>
